import React from 'react';
import { DatePicker, Segmented, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { getDashboardPeriodTooltipLines } from '../../utils/dates';
import styles from './styles/period-controls.module.scss';

const { RangePicker } = DatePicker;

function PeriodControls({
    timeFrame,
    dateRange,
    onTimeFrameChange,
    onDateRangeChange,
    options,
    showLabel = true,
    segmentedSize = 'small',
    pickerSize = 'small',
    presets,
    dateFormat = 'MMM D',
    containerClassName = '',
    labelClassName = '',
}) {
    const periodOptions = options.map(({ label, value }) => {
        const { line1, line2 } = getDashboardPeriodTooltipLines(value, dateRange);
        const tooltipTitle =
            line2 != null ? (
                <div>
                    <div>{line1}</div>
                    <div style={{ fontSize: '12px', marginTop: '4px' }}>{line2}</div>
                </div>
            ) : value === 'custom' ? (
                <div>
                    <div>{line1}</div>
                    <div style={{ fontSize: '12px', marginTop: '4px' }}>Select dates in the picker to set the range</div>
                </div>
            ) : (
                <div>{line1}</div>
            );

        return {
            label: (
                <Tooltip title={tooltipTitle} placement="bottom">
                    <span>{label}</span>
                </Tooltip>
            ),
            value,
        };
    });

    const defaultPresets = [
        { label: '7d', value: [dayjs().subtract(6, 'day'), dayjs()] },
        { label: '30d', value: [dayjs().subtract(29, 'day'), dayjs()] },
        { label: '90d', value: [dayjs().subtract(89, 'day'), dayjs()] },
    ];

    return (
        <div className={containerClassName || styles.container}>
            {showLabel && <span className={labelClassName || styles.label}>Period</span>}
            <Segmented
                size={segmentedSize}
                value={timeFrame}
                options={periodOptions}
                onChange={onTimeFrameChange}
            />
            {timeFrame === 'custom' && (
                <RangePicker
                    size={pickerSize}
                    value={dateRange}
                    onChange={onDateRangeChange}
                    allowClear
                    format={dateFormat}
                    presets={presets || defaultPresets}
                />
            )}
        </div>
    );
}

export default PeriodControls;
